export default "__VITE_ASSET__BLBcIhzD__"